export const ROUTINE_COLOR_OPTIONS = [
  { value: 'green', label: 'Yeşil', hex: '#52c41a' },
  { value: 'yellow', label: 'Sarı', hex: '#fadb14' },
  { value: 'red', label: 'Kırmızı', hex: '#ff4d4f' },
];

export const routineColorHex = (value) =>
  (ROUTINE_COLOR_OPTIONS.find((o) => o.value === value) || ROUTINE_COLOR_OPTIONS[0]).hex;
